// extracted by mini-css-extract-plugin
export default {"container":"BaseTabList_container__lD+ZI","group":"BaseTabList_group__z1-me","bordered":"BaseTabList_bordered__Z0XBY"};